import React from "react";
import styles from "./ReactTableBase.module.css";
import {useTable, useSortBy} from "react-table";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSortAsc, faSortDesc} from "@fortawesome/free-solid-svg-icons";
import LoaderSkeleton from "../Loader/LoaderSkeleton";

const caseInsensitiveSort = (rowA, rowB, columnId) => {
    const valA = typeof rowA.values[columnId] === 'string' ? rowA.values[columnId].toLowerCase() : rowA.values[columnId];
    const valB = typeof rowB.values[columnId] === 'string' ? rowB.values[columnId].toLowerCase() : rowB.values[columnId];

    if (valA > valB) return 1;
    if (valB > valA) return -1;
    return 0;
};

const ReactTableBase = ({ dataSource, columnsData, serverSideSorting = false, initialSortBy = [], onSortChange = () => {} }) => {
    const data = React.useMemo(() => dataSource, [dataSource]);

    const columns = React.useMemo(() => {
        return columnsData.map(column => {
            if (column.isBoolean) {
                return {
                    ...column,
                    sortType: (rowA, rowB) => {
                        return (rowA.original[column.accessor] === rowB.original[column.accessor]) ? 0 : (rowA.original[column.accessor] ? 1 : -1);
                    }
                };
            }
            return {
                ...column,
                sortType: caseInsensitiveSort,
            };
        });
    }, [columnsData]);

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        state: { sortBy },
    } = useTable(
        {
            columns,
            data,
            manualSortBy: serverSideSorting, // Active le tri manuel si serverSideSorting est true
            disableSortRemove: true, // Désactive le retrait du tri
            initialState: { sortBy: initialSortBy }, // Initialise le tri avec les paramètres de l'URL
        },
        useSortBy
    );

    React.useEffect(() => {
        if (serverSideSorting) {
            onSortChange({ sortBy });
        }
    }, [onSortChange, sortBy, serverSideSorting]);

    return (
        <table {...getTableProps()} className={styles.tableau}>
            <thead>
            {headerGroups.map(headerGroup => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map(column => (
                        <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                            {column.render('Header')}
                            <span className={column.isSorted ? (column.isSortedDesc ? styles.sorted + " " + styles.sortedAsc : styles.sorted + " " + styles.sortedDesc) : ''}>
                                {column.isSorted ? (column.isSortedDesc ? <FontAwesomeIcon icon={faSortDesc}/> : <FontAwesomeIcon icon={faSortAsc}/>) : ''}
                            </span>
                        </th>
                    ))}
                </tr>
            ))}
            </thead>

            <tbody {...getTableBodyProps()}>
            {rows.map(row => {
                prepareRow(row);
                return (
                    <tr {...row.getRowProps()}>
                        {row.cells.map(cell => (
                            <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                        ))}
                    </tr>
                );
            })}
            </tbody>
        </table>
    );
};

export default ReactTableBase;
